import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaArrowLeft, FaToggleOff, FaToggleOn } from "react-icons/fa";
import "./CatalogueDetails.css";
import { useToasts } from "react-toast-notifications";
import { GoArrowLeft } from "react-icons/go";
import { endpoint } from "../../api/endpoint";
import { apiHandler } from "../../api";
import { useDispatch, useSelector } from "react-redux";

const CatalogueDetails = () => {
  const dispatch = useDispatch();
  //   const canEditCatalogue = usePermission("CATALOGUE_REJECTION_EDIT");

  const { authData } = useSelector((state) => state.loginSlice);
  const { addToast } = useToasts();
  const location = useLocation();
  const navigate = useNavigate();
  const catalogue = location.state?.catalogue;

  if (!catalogue) {
    return <div>No details available. Please go back and try again.</div>;
  }

  const [resolvedStatus, setResolvedStatus] = useState(
    catalogue.catalog_resolved_status,
  );
  const [remarks, setRemarks] = useState(catalogue.remarks);

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleToggleStatus = async () => {
    const newStatus = !resolvedStatus;
    const updatedRemarks = remarks;

    try {
      const response = await apiHandler({
        url: `${endpoint.UPDATE_CATALOGUE}`,
        method: "PATCH",
        authToken: authData,

        data: {
          id: catalogue.id,
          catalog_resolved_status: newStatus,
          remarks: updatedRemarks,
        },
        dispatch,
      });

      if (response.data.status === 200) {
        addToast("Resolved status updated successfully!", {
          appearance: "success",
          autoDismiss: true,
        });

        setResolvedStatus(newStatus);
        setRemarks(updatedRemarks);
      } else {
        addToast("Failed to update resolved status!", {
          appearance: "error",
          autoDismiss: true,
        });
      }
    } catch (error) {
      //console.error("Error updating resolved status:", error);
      addToast("Error updating status. Please try again.", {
        appearance: "error",
        autoDismiss: true,
      });
    }
  };

  return (
    <div className="catalogue-detail-container">
      <div className="row align-items-center my-2">
        <div className="col-lg-6">
          <div className="topHeading pb-2">
            <button className="back-button" onClick={handleGoBack}>
              <GoArrowLeft />
            </button>{" "}
            Catalogue Rejection Details
          </div>
        </div>
      </div>

      <div className="container-fluid catalogue-detail-wrapper">
        <div className="mb-3">
          <div className="row">
            <div className="col-12">
              <strong>Domain:</strong> <span>{catalogue.domain}</span>
            </div>
          </div>
        </div>

        <div
          className="detail-box mb-3"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <div
            className="row"
            style={{ display: "flex", justifyContent: "center", width: "100%" }}
          >
            <div className="col-md-4 col-sm-12 d-flex justify-content-center mb-3">
              <strong>Bap ID:</strong> &nbsp;{" "}
              <span style={{ fontSize: "16px", color: "black" }}>
                {catalogue.bap_id}
              </span>
            </div>
            <div className="col-md-4 col-sm-12 d-flex justify-content-center mb-3">
              <strong>Transaction ID:</strong> &nbsp;
              <span style={{ fontSize: "16px", color: "black" }}>
                {catalogue.transaction_id}
              </span>
            </div>
            <div className="col-md-4 col-sm-12 d-flex justify-content-center mb-3">
              <strong>Message ID:</strong> &nbsp;
              <span style={{ fontSize: "16px", color: "black" }}>
                {catalogue.message_id}
              </span>
            </div>
          </div>
        </div>

        <div className="detail-box">
          <div className="row">
            <div className="col-md-6 col-sm-12 mb-3">
              <div style={{ display: "flex", gap: "45px" }}>
                <strong>Rejection Type:</strong>
                <span style={{ textTransform: "uppercase" }}>
                  {catalogue.catalog_rejection_type}
                </span>
              </div>
              <div className="mt-2 d-flex">
                <strong>Rejection Errors:</strong>
                <ol>
                  {catalogue.catalog_rejection_error?.map((error, index) => (
                    <li key={index}>
                      {error.type}: {error.message} (Code: {error.code})
                    </li>
                  ))}
                </ol>
              </div>
            </div>

            <div className="col-md-6 col-sm-12 mb-3">
              <div className="mb-2">
                {!resolvedStatus ? (
                  <span className="remarks-input-group mt-1">
                    <span style={{ fontSize: "16px", marginRight: "50px" }}>
                      <strong>Remarks:</strong>
                    </span>

                    <input
                      type="text"
                      value={remarks}
                      style={{ width: "100%", maxWidth: "350px" }}
                      onChange={(e) => setRemarks(e.target.value)}
                      placeholder="Enter remarks before status resolving..."
                    />
                    <button
                      onClick={handleToggleStatus}
                      //   disabled={!remarks || !canEditCatalogue}
                      disabled={!remarks}
                      className="mt-2"
                      style={{
                        backgroundColor: "#0DCAF0C7",
                        padding: "5px 12px",
                        marginBottom: "5px",
                        borderRadius: "5px",
                      }}
                    >
                      Submit
                    </button>
                  </span>
                ) : (
                  <div style={{ display: "flex", gap: "5px" }}>
                    <strong>Remarks:</strong>
                    <div>{remarks}</div>
                  </div>
                )}
              </div>

              <div className="mb-2" style={{ display: "flex", gap: "5px" }}>
                <strong>Resolved Status:</strong>{" "}
                <span>{resolvedStatus ? "Resolved" : "Unresolved"}</span>
              </div>

              {resolvedStatus && (
                <div className="mb-2">
                  <strong>Resolved At:</strong>{" "}
                  <span>
                    {new Date(catalogue.updated_at)
                      .toUTCString()
                      .split(" ")
                      .slice(0, 5)
                      .join(" ")}
                  </span>
                </div>
              )}

              <div style={{ display: "flex", gap: "5px" }}>
                <strong>Created At:</strong>{" "}
                <span>
                  {new Date(catalogue.timestamp)
                    .toUTCString()
                    .split(" ")
                    .slice(0, 5)
                    .join(" ")}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CatalogueDetails;
